// ajaxSelect replaces the contents of a specified element with the
// results of a call to
// the uri specified in the link
$(document).on('change', 'select.ajaxSelect', function (e) {
  e.preventDefault();
  var self = $(this);
  ht.triggerAjaxNavigate(self);
});
